import React, { useEffect, useRef, useState } from 'react';
import { ArrowLeft, Pencil } from 'lucide-react';
import axios from 'src/common/axiosInstance';
import CustomerWorkspace from './CustomerWorkspace';
import { CustomerSharingButton } from './CustomerSharing';
import LeadModal from 'src/features/MiniCRM/components/Leads/LeadModal';
import './CrmCustomerWorkspace.css';

/** Key this boundary by workspace + lead so another subject never sees an old draft. */
export default function CustomerWorkspacePage({ leadId, workspaceId, onBack, onDetails, onSaved }) {
  const [record, setRecord] = useState(null);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  const [editing, setEditing] = useState(false);
  const heading = useRef(null);
  useEffect(() => {
    let active = true;
    setRecord(null); setError('');
    axios.get(`/leads/${encodeURIComponent(leadId)}`, { headers: { 'X-Workspace-ID': workspaceId } })
      .then(({ data }) => {
        const next = data?.data || data;
        if (!active) return;
        if (String(next?.id) !== String(leadId)) { setError('This customer is unavailable.'); return; }
        setRecord(next);
      })
      .catch(error => {
        if (!active) return;
        setError([403,404].includes(error?.response?.status)
          ? 'This customer is unavailable or you no longer have access.'
          : 'Could not load this customer. Please try again.');
      });
    return () => { active = false; };
  }, [leadId, workspaceId, revision]);
  useEffect(() => { heading.current?.focus(); }, []);
  return <section className="crm-customer-page" aria-label="Customer workspace">
    <header className="crm-customer-page-header">
      <button type="button" className="crm-customer-back" onClick={onBack}><ArrowLeft size={17} />Back to leads</button>
      <h1 ref={heading} tabIndex={-1} className="crm-customer-page-sr">Customer workspace</h1>
      {record && <div className="crm-customer-page-actions"><CustomerSharingButton recordId={record.id} name={record.name} /><button type="button" onClick={() => setEditing(true)}><Pencil size={16} />Edit lead</button></div>}
    </header>
    {error ? <div className="crm-customer-page-state"><p role="alert">{error}</p><button type="button" onClick={() => setRevision(value => value+1)}>Try again</button></div>
      : !record ? <p className="crm-customer-page-state" role="status">Loading customer details…</p>
      : <CustomerWorkspace record={record} workspaceId={workspaceId} onEdit={() => setEditing(true)} onReturn={onDetails} />}
    {editing && record && <LeadModal leadId={record.id} workspaceId={workspaceId} pipelineId={record.stage?.pipeline_id} onClose={() => setEditing(false)} onSuccess={() => { setEditing(false); setRevision(value => value+1); onSaved?.(); }} />}
  </section>;
}
